<template>
  <div class="toggle-domain-blocking-status">
    <vs-switch id="targeting-publishers-websites-apps-table-switch-button" v-if="isDomain" class="mt-5 w-10" @click="checkCampaignsTargetingDomain()" :value="isSelected"></vs-switch>

    <CampaignsConfirmationPopup
      :campaigns="confirmCampaigns"
      :show="showConfirmationPopup"
      @confirm="updateStatus(); showConfirmationPopup=false"
      @hide="showConfirmationPopup=false"
      :boldText="params.data.name"
    />
  </div>
</template>

<script>
import CampaignsConfirmationPopup from '@/views/targeting/components/_publishers_partials/CampaignsConfirmationPopup.vue'

export default {
  components: {
    CampaignsConfirmationPopup
  },
  computed: {
    isDomain () {
      return !this.params.data.hasOwnProperty('open_domains_count')
    }
  },
  data () {
    return {
      isSelected: false,
      showConfirmationPopup: false,
      confirmCampaigns: []
    }
  },
  created () {
    this.isSelected = this.isOpen()
  },
  methods: {
    isBlocked () {
      return this.params.data.status === 0
    },
    isOpen () {
      return !this.isBlocked()
    },
    getAction () {
      return this.isOpen() ? 'block' : 'open'
    },
    isBlockAction () {
      return this.getAction() === 'block'
    },
    async updateStatus () {
      await window.axios.post(`/targeting/${this.getAction()}`, {
        domains: [this.params.data.id]
      })

      this.updateTableRows()

      this.params.context.parent.toaster.show = true
      this.params.context.parent.toaster.message = `${this.params.data.name} has been ${this.getAction()}ed`
    },
    async checkCampaignsTargetingDomain () {
      if (this.isBlockAction()) {
        const response = await window.axios.post('/targeting/campaigns-having-domains', {
          domains: [this.params.data.id]
        })

        if (response.data.payload.campaigns.length) {
          this.confirmCampaigns = response.data.payload.campaigns
          this.showConfirmationPopup = true
          return
        }
      }

      await this.updateStatus()
    },
    updateTableRows () {
      const categoryRow = this.params.node.parent.data

      this.params.node.parent.setData({
        ...categoryRow,
        open_domains_count: this.isBlockAction() ? categoryRow.open_domains_count - 1 : categoryRow.open_domains_count + 1,
        blocked_domains_count: this.isBlockAction() ? categoryRow.blocked_domains_count + 1 : categoryRow.blocked_domains_count - 1
      })

      // update the adset status when updating the ad
      this.$nextTick(() => {
        this.params.api.refreshCells({
          rowNodes: [this.params.node.parent],
          force: true
        })
      })

      this.params.node.setData({
        ...this.params.node.data,
        status: this.isSelected ? 0 : 1
      })

      this.$nextTick(() => {
        this.params.api.refreshCells({
          rowNodes: [this.params.node],
          force: true
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.toggle-domain-blocking-status::v-deep {
  .no-actions {
    border: 1px solid;
    padding: 8px 10px;
    border-radius: 5px;
  }

  .vs-switch-active {
    background-color: #0092d7;
  }

  .vs-switch-primary {
    background-color: red;
  }
}
</style>
